/* eslint-disable no-console */
import { Features } from 'common/constants/features';

import { isFeatureEnabled } from './isFeatureEnabled';
import { VISUAL_REFRESH } from './visualRefresh';

import type { FeatureKey } from '../types';

export const logEnabledFeatures = () => {
  console.log('*** Enabled features:');
  Object.entries(Features).forEach(([key]) => {
    console.log(`*** ${key}: ${isFeatureEnabled(key as FeatureKey)}`);
  });

  // Logged separately because a `?visualRefresh=` override makes the resolved value diverge from
  // the environment default printed above — and that divergence is exactly what you need to see
  // when someone reports the app "looking wrong".
  console.log(`*** VisualRefresh (resolved, incl. ?visualRefresh= override): ${VISUAL_REFRESH}`);

  const version = window._env_.VITE_APP_TAG;
  const commit = window._env_.VITE_APP_COMMIT;
  console.log('*** Natter version:', version, commit ? `(${commit}) ***` : '***');
};
